export const engagementAppGroupIdGetEmailResultsId = "/engagement/:app_group_id/get_email_results/:id";
